import React from 'react';

import { CleanLocalDeliveryMethod } from '../../../export-types/cleaned-types';
import { getFileV2ApiUrl } from '../../../utils/common.utils';
import { ExpandButton } from '../../row';

type DeliveryOrdersTabMethodRowProps = {
  method: CleanLocalDeliveryMethod;
  onToggleMethod: (warehouse: string) => void;
  collapsedMethods: string[];
};

export function DeliveryOrdersTabMethodRow(
  props: DeliveryOrdersTabMethodRowProps,
) {
  return (
    <div className={'d-flex flex-row '}>
      {props.method.logo?.id ? (
        <img
          alt={'logo'}
          className={'m-2'}
          src={getFileV2ApiUrl(props.method.logo.id)}
          style={{ maxWidth: 120 }}
        />
      ) : (
        <div className="ms-2 fs-24">{props.method.name}</div>
      )}

      <div className={'mleft-auto'}>
        <ExpandButton
          onToggle={() => props.onToggleMethod(props.method.id)}
          collapsed={props.collapsedMethods.includes(props.method.id)}
        />
      </div>
    </div>
  );
}
